// extracted by mini-css-extract-plugin
module.exports = {"block":"Select_block__NqqZZ","required":"Select_required__2_Wgi","root":"Select_root__2liGf","bordered":"Select_bordered__1cRpp","error":"Select_error__3XkPl"};